module.exports = __webpack_public_path__ + "static/img/mf_slider3.e951f37.webp";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/mf_slider3.webp
// module id = tqmT
// module chunks = 5